import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import CircleChart from "./CircleChart";
import { commonApi } from "@/api/common";
const AssetCategoryRatio = ({ className = "", }) => {
    // 状态存储图表数据
    const [chartData, setChartData] = useState([]);
    // 从接口拉取数据
    useEffect(() => {
        commonApi.statSubsystemData().then((res) => {
            if (res.data && Array.isArray(res.data)) {
                setChartData(res.data); // 直接赋值接口返回的数组
            }
        });
    }, []);
    // 🔥 计算所有项目的总金额
    const totalAmountSum = chartData.reduce((sum, item) => {
        return sum + (item.totalAmount || 0);
    }, 0);
    return (_jsx("div", { className: `
        relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
        flex 
        flex-wrap 
        justify-around 
        gap-[0.4rem]
        min-h-0
        mb-[0.2rem]
        ${className}
      `, children: chartData.map((item, index) => {
            // 占比 radio：保留两位小数（推荐写法）
            const radio = totalAmountSum > 0 && item.totalAmount
                ? Math.round((item.totalAmount / totalAmountSum) * 100) / 100
                : 0;
            const amount = Math.round((item.totalAmount / 10000) * 100) / 100;
            return (_jsx(CircleChart, { current: item.total, radio: radio, cname: item.subsystemName, amount: amount, color: "#1d71c4" }, index));
        }) }));
};
export default AssetCategoryRatio;
